import { Pipe, PipeTransform } from '@angular/core';
import { ReasonRemoveOrder } from '../values/reson-remove-order.value';

@Pipe({
  name: 'reasonRemoverOrder',
  standalone: false,
})
export class PurchaseOrderReasonRemovePipe implements PipeTransform {
  private static readonly LABEL_MAP: Readonly<Record<ReasonRemoveOrder, string>> = {
    [ReasonRemoveOrder.INVOICE_BILLED_HIGHER]: 'NF faturada a maior',
    [ReasonRemoveOrder.INVOICE_BILLED_LOWER]: 'NF faturada a menor',
    [ReasonRemoveOrder.IMPROPER_INVOICE]: 'NF Indevida',
    [ReasonRemoveOrder.PURCHASE_ORDER_HIGHER]: 'Pedido Compra maior',
    [ReasonRemoveOrder.PURCHASE_ORDER_LOWER]: 'Pedido Compra menor',
    [ReasonRemoveOrder.PRIOR_TO_DEMAND]: 'Pré-tratamento interno',
    [ReasonRemoveOrder.OTHERS]: 'Outros',
  } as const;

  private static readonly DEFAULT_LABEL = '-';

  transform(value: ReasonRemoveOrder): string {
    return PurchaseOrderReasonRemovePipe.LABEL_MAP[value] ?? PurchaseOrderReasonRemovePipe.DEFAULT_LABEL;
  }
}
